import React, { Suspense, type ReactElement, type ReactNode, lazy } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import VConsole from "vconsole"; // import vconsole
import ReactDOM from "react-dom/client";
import "globalthis/auto"; // polyfill globalThis
import Layout from "./components/pagesCom/layout/layout";
import "./global.css";
import "@/assets/iconfont/iconfont.css";
import store from "./store";
import Loading from "@/components/Loading/index";
import "./utils/shence";

const MainLoading = lazy(() => import("./pages/Loading/index"));
const Main = lazy(() => import("./pages/Main/page"));
const MonthExcutePerformanceTarget = lazy(
  () => import("@/pages/monthExcutePerformanceTarget/index")
);
const MyProductIncome = lazy(() => import("@/pages/myProductIncome/page"));
const MyReply = lazy(() => import("@/pages/MyReply/index"));
const ProjectInspireTargetDetail = lazy(
  () => import("@/pages/projectInspireTargetDetail/index")
);
const MyReplyId = lazy(() => import("@/pages/MyReply/id/[id]"));
const MyReplySubmit = lazy(() => import("@/pages/MyReply/MyReplySubmit"));

// import.meta.env.MODE !== 'production' && new VConsole();
if (process.env.REACT_APP_ENV !== "production") {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const vconsole = new VConsole(); // vConsole移动端调试插件
}

let reactRoot: ReturnType<typeof ReactDOM.createRoot> | null = null;

function initApp() {
  if (!reactRoot) {
    const root = ReactDOM.createRoot(document.getElementById("root")!);
    reactRoot = root;
    root.render(
      <Provider store={store}>
        <BrowserRouter>
          <Suspense fallback={<Loading />}>
            <Layout>
              <Routes>
                <Route path="/" element={<MainLoading />} />
                <Route path="/Main/*" element={<Main />} />
                <Route
                  path="/monthExcutePerformanceTarget"
                  element={<MonthExcutePerformanceTarget />}
                />
                <Route
                  path="/MyProductIncome/*"
                  element={<MyProductIncome />}
                />
                <Route path="/MyReply" element={<MyReply />} />
                <Route
                  path="/MyReply/MyReplySubmit"
                  element={<MyReplySubmit />}
                />
                <Route path="/MyReply/id/:id" element={<MyReplyId />} />
                <Route
                  path="/ProjectInspireTargetDetail"
                  element={<ProjectInspireTargetDetail />}
                />
              </Routes>
            </Layout>
          </Suspense>
        </BrowserRouter>
      </Provider> as any
    );
  }
}

// requestAnimationFrame(() => {
//   initApp();
// });
initApp();

// 通知骨架屏隐藏
setTimeout(() => {
  // 扩展 Window 接口，添加 appReady 属性
  if (typeof window.appReady === "function") {
    window.appReady();
  }
}, 300);

declare global {
  interface Window {
    appReady?: () => void;
  }
}
